import { Swiper, Navigation } from 'swiper'
Swiper.use([Navigation])

export default () => {
    // eslint-disable-next-line
    new Swiper('.partners-slider .swiper-container', {
        spaceBetween: 20,
        slidesPerView: 'auto',
        loop: true,
        loopFillGroupWithBlank: true,
        slidesPerGroup: 1,
        // centeredSlides: true,
        navigation: {
            nextEl: '.partners-slider__next',
            prevEl: '.partners-slider__previous',
        },
        // on: {
        //     slideChange(swiper) {
        //         const targetSlide = swiper.realIndex
        //         const elActiveSlideCopy = document.querySelector(
        //             '.partners-slider .partners-slider__copy-item[data-active]'
        //         )
        //         delete elActiveSlideCopy.dataset.active

        //         const elTargetCopy = document.querySelector(
        //             `.partners-slider .partners-slider__copy-item[data-slide-index="${targetSlide}"]`
        //         )
        //         elTargetCopy.dataset.active = 'true'
        //     },
        //     setTranslate(swiper, translate) {
        //         //
        //     },
        // },
    })
}
